<template>
  <div class="container">
    <div class="mainContainer" :class="{ normalScript: type == 1 }">
      <!-- 封面展示 -->
      <div
        class="setContainer"
        :class="{ thumbLine: thumbType == 0 }"
        style="align-items: center"
      >
        <div class="label">
          <p><span class="require">*</span>展示封面</p>
        </div>
        <div
          class="thumbTypeContainer"
          style="display: inline-block; width: fit-content"
        >
          <el-radio v-model="thumbType" label="0" v-if="type == 1 || type == 2"
            >无封面</el-radio
          >
          <el-radio v-model="thumbType" label="1">小封面</el-radio>
          <el-radio v-model="thumbType" label="0.9" v-if="is_horizontal != 2"
            >大封面</el-radio
          >
          <el-radio v-model="thumbType" label="3" v-if="type != 2"
            >三封面</el-radio
          >
        </div>
        <p class="getThumbAuto" @click="getThumbAuto" v-if="type != 2">
          自动获取
        </p>
      </div>
      <!-- 上传资源部分，这个在视频和图集的时候有 -->
      <div class="thumbContainer" v-show="thumbType > 0 && type != 2">
        <div
          v-for="(item, index) in thumbList"
          :key="index"
          v-show="thumbType > index"
          class="thumbEditContainers"
        >
          <img
            src="../../../assets/script/uploadC.png"
            v-show="!item"
            @click="toUpload(index)"
          />
          <img
            :src="item"
            v-show="item"
            @mouseover="thumbActionIndex = index"
          />
          <div
            class="thumbEditContainer"
            v-show="thumbActionIndex == index"
            @mouseleave="thumbActionIndex = -1"
          >
            <p class="thumbBtn" @click="toThumbEdit(index)">裁剪</p>
            <p class="thumbBtn" @click="toUpload(index)">上传</p>
          </div>
        </div>
      </div>
      <div
        style="margin-top: 8px; color: #999; padding-left: 105px"
        v-show="thumbType > 0 && type != 2"
      >
        建议上传图片比例 {{ thumbType == 0.9 ? "16:9" : "4:3" }}
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor" style="display: block">
        <div style="display: flex; align-items: center">
          <p class="label"><span class="require">*</span>顶端号</p>
          <el-radio-group v-model="accountSearchType" class="accountSearchType">
            <el-radio :label="1">精确查找</el-radio>
            <el-radio :label="0">模糊匹配</el-radio>
          </el-radio-group>
        </div>
        <el-select
          v-model="accountName"
          filterable
          remote
          reserve-keyword
          placeholder="请搜索顶端号"
          :remote-method="getTopAccountList"
          :loading="accountLoading"
          @change="accountPick"
          style="margin: 10px 0 0 100px; width: calc(100% - 100px)"
        >
          <el-option
            v-for="item in accountList"
            :key="item.u_id"
            :label="item.u_nickname"
            :value="item.u_id"
            class="accountSearchContain"
          >
            <img :src="item.u_avatar" class="accountHead" />
            <p class="accountName">{{ item.u_nickname }}</p>
          </el-option>
        </el-select>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor" style="align-items: flex-start">
        <p class="label">来源</p>
        <el-input
          v-model="source"
          type="textarea"
          maxlength="50"
          placeholder="请输入来源"
          resize="none"
          rows="2"
          show-word-limit
        />
      </div>
      <!-- 作者有 -->
      <!-- <div class="setContainer" v-if="!isEditor">
        <p class="label">作者<span class="require">*</span></p>
        <el-input
          style="width: 100%"
          v-model="authorName"
          placeholder="请输入作者名字"
          disabled
        ></el-input>
      </div> -->
      <!-- 编辑老师、作者通用 -->
      <div class="setContainer" style="align-items: flex-start">
        <div class="abstractContain">
          <div class="label">
            <p>文章摘要</p>
            <!-- <p class="getAiAbstract" @click="getAiAbstract()">摘要推荐</p> -->
          </div>
        </div>
        <el-input
          v-model="abstract"
          type="textarea"
          maxlength="200"
          placeholder="请输入摘要"
          resize="none"
          rows="3"
          v-loading="aiTitleLoading"
          show-word-limit
        />
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="is_reverse_author == 0">
        <p class="label">文章分类</p>
        <SelectTree v-model="channel" :list="channels"></SelectTree>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor && this.n_id">
        <p class="label">关键词</p>
        <div class="keywordsbox">
          <div class="keywordsbox__left">
            <span v-if="!keywords.length" class="noData">暂无关键词</span>
            <template v-else>
              <span
                class="keywordsbox__left__item"
                v-for="item in keywords"
                :key="item.id"
                >{{ item.keyword }}</span
              >
            </template>
          </div>
        </div>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label"><span class="require">*</span>编辑</p>
        <el-input
          style="width: 100%"
          v-model="editor"
          placeholder="请输入编辑，如有多位，请使用中文逗号隔开"
          clearable
        ></el-input>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label">供稿记者</p>
        <el-input
          style="width: 100%"
          v-model="reporter"
          placeholder="请输入供稿记者，如有多位，请使用中文逗号隔开"
          clearable
        ></el-input>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label">
          <span>所属员工</span>
          <el-popover
            placement="top-start"
            width="700"
            trigger="hover"
            content="稿件归属逻辑：稿件作者>维护者>编辑（即当稿件作者不为空时优先归于稿件作者，稿件作者为空时优先归于维护者，若稿件作者和维护者都为空时则归于编辑）"
          >
            <span slot="reference" style="color: #ea0e0e; cursor: pointer"
              ><i class="el-icon-question"></i
            ></span>
          </el-popover>
        </p>
        <el-select
          v-model="belongtoValue"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="选择多人时考核系统自动归给首个员工，多人共有稿件自行分配"
          :remote-method="remoteMethod"
          :loading="belongtoLoading"
        >
          <el-option
            v-for="item in belongtoOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 作者有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label">允许赞赏</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <el-radio v-model="allow_reward" label="1">开启</el-radio>
            <el-radio v-model="allow_reward" label="0">关闭</el-radio>
          </div>
        </div>
      </div>
      <!-- 编辑老师、作者通用 -->
      <div class="setContainer originalContainer">
        <p class="label">作品声明</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <div
              class="originalRadio"
              v-for="(item, index) in originalList"
              :key="index"
              @click="originalClick(item)"
            >
              <img
                src="../../../assets/originalChecked.png"
                class="originalIcon"
                v-if="is_original == index + 1"
              />
              <img
                src="../../../assets/originalUncheck.png"
                class="originalIcon"
                v-else
              />
              <p class="originalText">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="setContainer">
        <p class="label">允许评论</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <el-radio v-model="allowCommit" label="0">是</el-radio>
            <el-radio v-model="allowCommit" label="1">否</el-radio>
          </div>
        </div>
      </div> -->
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label">AI评论</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <el-radio v-model="allow_ai_comment" label="1">开启</el-radio>
            <el-radio v-model="allow_ai_comment" label="0">关闭</el-radio>
          </div>
        </div>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label"><span class="require">*</span>发稿类型</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <el-radio v-model="editor_news_type" label="1">媒体转载</el-radio>
            <el-radio v-model="editor_news_type" label="2">顶端原创</el-radio>
            <el-radio v-model="editor_news_type" label="3">自定义soft</el-radio>
            <el-radio v-model="editor_news_type" label="4">指令宣推</el-radio>
            <el-radio v-model="editor_news_type" label="5">一般用户</el-radio>
          </div>
        </div>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor">
        <p class="label">是否展示</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <el-radio v-model="isHidden" label="0">展示</el-radio>
            <el-radio v-model="isHidden" label="1">隐藏</el-radio>
          </div>
        </div>
      </div>
      <!-- 编辑老师有 -->
      <div class="setContainer" v-if="isEditor && isThemeWhite">
        <p class="label">公祭主题</p>
        <div class="thumbTypeContainer">
          <div class="radioContainer" style="display: inline-block">
            <el-radio v-model="setTheme" label="0">开启</el-radio>
            <el-radio v-model="setTheme" label="1">关闭</el-radio>
          </div>
        </div>
      </div>
    </div>

    <div class="submitBtnContainer">
      <div class="innerContainer">
        <!-- 只有在文章的时候才有字和图的监听 -->
        <div class="leftPart">
          <div class="toTopContain" @click="toTop()" v-if="!isScrollTop">
            <p class="topText">回到顶部</p>
            <img src="../../../assets/upArrow.jpg" class="toTopIcon" />
          </div>
          <div class="toTopContain" @click="toBottom()" v-if="isScrollTop">
            <p class="topText">发文设置</p>
            <img src="../../../assets/downArrow.png" class="toTopIcon" />
          </div>
          <div
            v-if="type == 1"
            style="
              font-size: 14px;
              font-family: 'PingFang SC';
              font-weight: 400;
              color: #666666;
              line-height: 17px;
            "
          >
            共 {{ text_number }} 字
          </div>
        </div>

        <div class="rightPart">
          <!-- 这个是文章和图集的提交按钮 -->
          <div v-if="type == 1 || type == 3">
            <div
              style="width: 80px; height: 36px; padding: 0"
              class="submitBtn"
              @click="preVis"
            >
              预览
            </div>
            <div
              style="width: 80px; height: 36px; padding: 0"
              class="submitBtn"
              @click="checkAudit(1, 1)"
              v-if="!this.isEditor || !$route.query.scriptId"
            >
              {{ $route.query.draftId ? "保存" : "存草稿" }}
            </div>
            <div
              style="width: 122px; height: 36px; padding: 0"
              class="submitBtn"
              @click="generateNewsDraftPreview()"
              v-if="isEditor && !$route.query.scriptId"
            >
              生成预览链接
            </div>
            <div
              style="width: 122px; height: 36px; padding: 0"
              class="submitBtn"
              @click="isClockChange()"
            >
              定时发布
            </div>
            <div
              style="width: 122px; height: 36px; padding: 0"
              type="primary"
              class="submitBtn"
              @click="checkAudit(2, 1)"
            >
              提交
            </div>
          </div>

          <!-- 这个是视频 -->
          <div v-if="type == 2">
            <div
              style="width: 80px; height: 36px; padding: 0"
              class="submitBtn"
              @click="checkAudit(1, 1)"
              v-if="!this.isEditor || !$route.query.scriptId"
            >
              {{ $route.query.draftId ? "保存" : "存草稿" }}
            </div>
            <div
              style="width: 122px; height: 36px; padding: 0"
              class="submitBtn"
              @click="generateNewsDraftPreview()"
              v-if="isEditor && !$route.query.scriptId"
            >
              生成预览链接
            </div>
            <div
              style="width: 122px; height: 36px; padding: 0"
              class="submitBtn"
              @click="isClockChange()"
            >
              定时发布
            </div>
            <div
              style="width: 122px; height: 36px; padding: 0"
              type="primary"
              class="submitBtn"
              @click="checkAudit(2, 1)"
            >
              提交
            </div>
          </div>
        </div>
      </div>
    </div>

    <input type="file" @change="fileChange" id="upload" />

    <el-dialog
      title="封面剪裁"
      :visible.sync="dialogVisible"
      top="2vh"
      class="thumbCutContainer"
      width="900px"
      :close-on-click-modal="false"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="dialogVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="finish">确认</div>
      </div>
    </el-dialog>

    <el-dialog
      title="请完成实名认证"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img
            src="../../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="草稿预览二维码"
      width="320px"
      :visible.sync="qrCodeShow"
      top="5vh"
      class="qrCodeDialog"
    >
      <div id="qrCode" ref="qrCodeDiv"></div>
    </el-dialog>

    <el-dialog
      title="定时发布"
      width="420px"
      :visible.sync="clockShow"
      top="5vh"
      class="clockDialog"
      :before-close="closeClockDialog"
    >
      <p class="intro">
        请选择当前时间后{{ formatSeconds(clockStartTime) }}至7天进行定时发布
      </p>
      <el-date-picker
        v-model="publishTime"
        type="datetime"
        placeholder="选择日期时间"
        value-format="yyyy-MM-dd HH:mm:00"
        :clearable="false"
      >
      </el-date-picker>
      <p class="timeView" v-show="publishTime">
        将于北京时间<span class="timeSelected">{{ publishTime }}</span
        >发布
      </p>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="clockShow = false">取消</div>
        <div class="submitBtn" type="primary" @click="checkAudit(2)">
          定时发布
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  RESOURCE_HOST,
  USER_HOST,
  NEWS_HOST,
  MEDIA_HOST,
  BI_HOST,
  SWNEWS_HOST,
} from "../../../constants/apiHosts";
import { html2json, json2html } from "html2json";
import { mapActions } from "vuex";
import { VueCropper } from "vue-cropper";
import SelectTree from "@/components/SelectTree";
import { HS_upload } from "./../../../utils/huoshanUpload";
import dbRequest from "../../../plugin/request-bd";
import QRCode from "qrcodejs2";
import { setToken } from "@/utils/libs/auth";

export default {
  components: {
    SelectTree,
    VueCropper,
  },
  name: "InfoSet",
  data() {
    return {
      belong_id: "",
      nm_id: "",
      n_id: "",
      thumbType: "0",
      thumbList: ["", "", ""],
      uploadIndex: 0,
      authorName: "",
      auditType: "0",
      isLocation: "0",
      lon: "",
      lat: "",
      address: "",
      auditActive: "first",
      auditSearch: "",
      recentAudit: "",
      recentAudits: [],
      n_release_status: 0,
      submitting: false,
      accountList: [],
      accountId: "",
      accountName: "",
      accountLoading: false,
      timeout: null,
      source: "",
      abstract: "",
      channel: "",
      channels: [],
      keywords: [],
      editor: "",
      reporter: "",
      allow_reward: "1",
      is_original: "0",
      allowCommit: "0",
      allowAd: "0",
      isEditor: false,
      accountPickThisTime: {},
      thumbActionIndex: -1,
      thumbCutIndex: -1,
      dialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 900, // 默认生成截图框宽度
        autoCropHeight: 700, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [4, 3], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        canMove: true,
        height: false, //是否按照设备的dpr 输出等比例图片
        enlarge: 2, //图片根据截图框输出比例倍数
      },
      global_id: "",
      reward_auth: false,
      original_auth: true,
      isClock: "0",
      publishTime: "",
      clockPreinstall: "",
      clockStartTime: 7200000,
      certificationVisible: false,
      u_cert: 0,
      accountSearchType: 1,
      aiTitleLoading: false,
      isThemeWhite: false,
      setTheme: "1",
      allow_ai_comment: "1",
      editor_news_type: 0,
      qrCodeShow: false,
      dhyPublished: false,
      clockShow: false,
      isScrollTop: true,
      isHidden: "0",
      originalList: [],
      is_reverse_author: 0,
      belongtoOriginList: [],
      belongtoOptions: [],
      belongtoValue: [],
      belongtoLoading: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    resource_url: {
      type: Array,
      default: [],
    },
    type: {
      type: String,
      default: "",
    },
    material_ids: {
      type: String,
      default: "",
    },
    text_number: {
      type: Number,
      default: 0,
    },
    img_number: {
      type: Number,
      default: 0,
    },
    topicIds: {
      type: Array,
      default: [],
    },
    videoOriginUrl: {
      type: String,
      default: "",
    },
    originThumb: {
      type: String,
      default: "",
    },
    video_id: {
      type: String,
      default: "",
    },
    videoCover: {
      type: String,
      default: "",
    },
    is_horizontal: {
      type: Number,
      default: 1,
    },
    abstractAi: {
      type: String,
      default: "",
    },
    video_length: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
    is_horizontal(newVal, oldVal) {
      if (newVal == 2 && this.thumbType == "0.9") {
        this.thumbType = "1";
      }
    },
    abstractAi(newVal, oldVal) {
      this.abstract += newVal;
    },
  },
  created() {
    this.isEditor = this.$route.query.token ? true : false;

    if (this.$route.query.uid && !this.$route.query.scriptId) {
      this.getThemeWhiteUser();
    }

    //视频是2，图集是3
    if (this.type == 2) {
      this.thumbType = "1";
    } else if (this.type == 3) {
      this.thumbType = "1";
    }

    this.getUserInfo().then(() => {
      setTimeout(() => {
        if (localStorage.getItem("u_nickname")) {
          this.authorName = localStorage.getItem("u_nickname");
          this.u_cert = localStorage.getItem("u_cert") == 1 ? 1 : 0;
          if (!this.u_cert && this.$route.query.mediaId) {
            this.certificationVisible = true;
          }
        } else {
          location.reload();
        }
        this.is_reverse_author = localStorage.getItem("is_reverse_author");
      }, 1000);
    });
    this.getChannelList();
    this.getUserLevelList();
    this.getIsOriginalDesc();

    if (this.$route.query.ar_type != 3) {
      this.accountList = localStorage.getItem("accountHistory")
        ? JSON.parse(localStorage.getItem("accountHistory"))
        : [];
    }

    this.trackFn();
  },
  mounted() {
    if (this.type == 1) {
      const element = document.getElementsByTagName("html")[0];
      window.addEventListener("scroll", (e) => {
        var scrollHeight = document.documentElement.scrollHeight;
        var clientHeight = window.innerHeight;
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop + clientHeight >= scrollHeight) {
          this.isScrollTop = false;
        } else if (scrollTop == 0) {
          this.isScrollTop = true;
        }
      });
    } else {
      const element = document.getElementsByClassName("memberContainer")[0];
      element.addEventListener("scroll", () => {
        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
          this.isScrollTop = false;
        } else if (element.scrollTop == 0) {
          this.isScrollTop = true;
        }
      });
    }
  },
  methods: {
    ...mapActions("common", ["getUserInfo"]),
    trackFn() {
      dbRequest({
        url: `${BI_HOST}/bd`,
        method: "POST",
        params: {
          b_type: "创作中台编辑页",
        },
      }).then((res) => {
        if (res.data.code == 200) {
        } else {
          //this.$message.error(res.data.msg);
        }
      });
    },
    //这个是预览的操作
    preVis() {
      this.$emit("preview", this.setTheme);
    },
    getDraftDetail() {
      this.$axios
        .get(`${RESOURCE_HOST}/api/draft/show?id=${this.belong_id}`)
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;

            if (detail.nd_cover_show_type == 1) {
              this.thumbType = "1";
              this.thumbList = [detail.nd_cover_url[0], "", ""];
            } else if (detail.nd_cover_show_type == 4) {
              this.thumbType = "3";
              this.thumbList = detail.nd_cover_url;
            } else if (detail.nd_cover_show_type == 3) {
              this.thumbType = "0";
              this.thumbList = ["", "", ""];
            } else if (detail.nd_cover_show_type == 2) {
              this.thumbType = "0.9";
              this.thumbList = [detail.nd_cover_url[0], "", ""];
            }
            this.authorName = detail.u_nickname;
            this.editor = detail.nd_modify_user;
            this.reporter = detail.nd_author;
            this.abstract = detail.nd_abstract.substr(0, 200);
            this.allowCommit = detail.nd_is_allow_comment == "Y" ? "0" : "1";
            this.allowAd = detail.nd_is_allow_adv == "Y" ? "0" : "1";
            this.channel = detail.nd_category == 0 ? "" : detail.nd_category;
            this.accountId = detail.u_id;
            this.accountName = detail.u_nickname;
            this.source = detail.nd_source.substr(0, 50);
            this.is_original = detail.nd_is_original || "0";
            this.allow_reward = detail.nd_reward + "";
            this.clockPreinstall = detail.nd_clock_time || "";
            this.global_id = detail.global_id;

            if (this.clockPreinstall) {
              this.publishTime = this.clockPreinstall;
              this.isClock = "1";
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getScriptDetail() {
      this.$axios
        .get(
          this.$route.query.isPub == 1
            ? `${SWNEWS_HOST}/api/news/getNewsInfo?id=${this.$route.query.nid}`
            : `${RESOURCE_HOST}/api/manuscript/show?id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (this.$route.query.isPub == 1) {
              for (let key in res.data.data) {
                if (key.indexOf("n_") >= 0 && key != "n_id") {
                  res.data.data[key.replace("n_", "nm_")] = res.data.data[key];
                }
              }
            }

            let detail = res.data.data;

            if (detail.nm_cover_show_type == 1) {
              this.thumbType = "1";
              this.thumbList = [detail.nm_cover_url[0], "", ""];
            } else if (detail.nm_cover_show_type == 4) {
              this.thumbType = "3";
              this.thumbList = detail.nm_cover_url;
            } else if (detail.nm_cover_show_type == 3) {
              this.thumbType = "0";
              this.thumbList = ["", "", ""];
            } else if (detail.nm_cover_show_type == 2) {
              this.thumbType = "0.9";
              this.thumbList = [detail.nm_cover_url[0], "", ""];
            }
            this.n_release_status = detail.n_release_status;
            this.nm_id = detail.nm_id;
            if (detail.n_id) {
              this.n_id = detail.n_id;
            }
            if (detail.audit_center_user) {
              for (let key in this.recentAudits) {
                if (key == detail.audit_center_user) {
                  this.auditType = "1";
                  this.recentAudit = this.recentAudits[key].u_cellphone;
                }
              }
            }
            this.authorName = detail.u_nickname;
            this.editor = detail.nm_modify_user;
            this.reporter = detail.nm_author;
            this.abstract = detail.nm_abstract.substr(0, 200);
            this.allowCommit = detail.nm_is_allow_comment == "Y" ? "0" : "1";
            this.allowAd = detail.nm_is_allow_adv == "Y" ? "0" : "1";
            this.channel = detail.nm_category == 0 ? "" : detail.nm_category;
            this.accountId = detail.u_id;
            this.accountName = detail.u_nickname;
            this.source = detail.nm_source.substr(0, 50);
            this.is_original = detail.nm_is_original || "0";
            this.global_id = detail.global_id ? detail.global_id : "";
            this.allow_reward = detail.nm_reward + "";
            this.clockPreinstall = detail.nm_clock_time || "";
            this.isHidden = detail.nm_is_hidden + "" || "0";

            if (detail.editor_news_type > 0) {
              this.editor_news_type = detail.editor_news_type + "";
            }
            if (this.clockPreinstall) {
              this.publishTime = this.clockPreinstall;
              this.isClock = "1";
            }
            if (this.isEditor && this.n_id) {
              this.handleClickExtract();
            }
            if (this.$route.query.uid) {
              this.getThemeWhiteUser();
            }

            if (detail.belongto_user != "") {
              try {
                let belongto_user = JSON.parse(detail.belongto_user);
                belongto_user.forEach((item) => {
                  this.belongtoValue.push(
                    item.belongto_d_id + "/" + item.belongto_user_id
                  );
                  this.belongtoOptions.push({
                    value: item.belongto_d_id + "/" + item.belongto_user_id,
                    label: `${item.belongto_user_name}(${item.belongto_d_name})`,
                  });
                });
                this.belongtoOriginList = this.removeDuplicatesByKeys(
                  JSON.parse(JSON.stringify(belongto_user)),
                  ["belongto_d_id", "belongto_user_id"]
                );
              } catch (error) {
                console.log(error);
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getDhyDetail() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/common/cloudnews/getTmpInfo?big_cloud_id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;

            if (detail.n_type == 2) {
              detail.n_cover_show_type = 2;
            }

            try {
              detail.n_cover_url = eval("(" + detail.n_cover_url + ")");
            } catch (error) {}

            if (detail.n_cover_show_type == 1) {
              this.thumbType = "1";
              this.thumbList = [detail.n_cover_url[0], "", ""];
            } else if (detail.n_cover_show_type == 4) {
              this.thumbType = "3";
              this.thumbList = detail.n_cover_url;
            } else if (detail.n_cover_show_type == 3) {
              this.thumbType = "0";
              this.thumbList = ["", "", ""];
            } else if (detail.n_cover_show_type == 2) {
              this.thumbType = "0.9";
              this.thumbList = [detail.n_cover_url[0], "", ""];
            }
            this.authorName = detail.u_nickname;
            this.editor = detail.n_modify_user;
            this.reporter = detail.n_author;
            this.abstract = detail.n_abstract.substr(0, 200);
            this.allowCommit = detail.n_is_allow_comment == "Y" ? "0" : "1";
            this.allowAd = detail.n_is_allow_adv == "Y" ? "0" : "1";
            this.channel = detail.n_category == 0 ? "" : detail.n_category;
            this.accountId = detail.u_id;
            this.accountName = detail.u_nickname;
            this.source = detail.n_source.substr(0, 50);
            this.is_original = detail.n_is_original || "0";
            this.global_id = detail.global_id ? detail.global_id : "";
            //this.allow_reward = detail.n_reward + "";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getMediaDetail() {
      this.$axios
        .get(
          `${MEDIA_HOST}/biz/outer/news/queryBy?id=${this.belong_id}&&appId=${this.$route.query.appId}&&orgId=${this.$route.query.orgId}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;

            if (detail.n_type == 2) {
              detail.nmCoverType = 2;
            }

            if (detail.nmCoverType == 1) {
              this.thumbType = "1";
              this.thumbList = [detail.nmCoverUrls[0], "", ""];
            } else if (detail.nmCoverType == 4) {
              this.thumbType = "3";
              this.thumbList = detail.nmCoverUrls;
            } else if (detail.nmCoverType == 3) {
              this.thumbType = "0";
              this.thumbList = ["", "", ""];
            } else if (detail.nmCoverType == 2) {
              this.thumbType = "0.9";
              this.thumbList = [detail.nmCoverUrls[0], "", ""];
            }

            this.abstract = detail.nmAbstract.substr(0, 200);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toUpload(index) {
      this.uploadIndex = index;
      let upload = document.getElementById("upload");
      upload.value = "";
      upload.click();
    },
    //内审人
    getAuditUser() {
      if (this.$route.query.scriptId) {
        this.belong_id = this.$route.query.scriptId;
        this.getScriptDetail();
      }
    },
    checkAudit(save_type, noCloack) {
      if (noCloack) {
        this.isClock = "0";
      }
      if (this.auditType == 0) {
        this.submit(save_type, "");
      } else if (this.auditType == 1 && this.recentAudit == "") {
        this.$message({
          message: "请输入审核人手机号",
          type: "warning",
        });
      } else {
        this.$axios
          .post(`${RESOURCE_HOST}/api/common/getaudituser`, {
            cellphone: this.recentAudit,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.submit(save_type, res.data.data);
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    //深度遍历,本身想写深度优先查询，想了想，因为最后要生成一个新的对象
    //这里主要是一个通过递归实现的深拷贝
    //注意的是，单层遍历的逻辑，输入值，输出值
    recursive(data) {
      var type = this.judgeType(data);
      var obj;
      //将jpg改成
      if (data.tag == "video" && data.attr) {
        data.attr.controls = "controls";
        data.attr.controlsList = "nodownload";
      } else if (data.attr && data.attr["data-mce-p-src"]) {
        data.attr["data-mce-p-src"] = "";
      }
      if (data.tag == "img" && data.attr && !data.attr["src"]) {
        if (data.attr["data-src"]) {
          data.attr["src"] = data.attr["data-src"];
        } else {
          data.attr["src"] = "";
        }
      }
      if (type === "array") {
        obj = [];
      } else if (type == "object") {
        obj = {};
      } else {
        //基本数据类型直接返回
        return data;
      }
      if (type == "array") {
        for (var i = 0; i < data.length; i++) {
          obj.push(this.recursive(data[i]));
        }
      } else if (type == "object") {
        for (var key in data) {
          obj[key] = this.recursive(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      var toString = Object.prototype.toString;
      var map = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regExp",
        "[object Undefined]": "undefined",
        "[object Null]": "null",
        "[object Object]": "object",
      };
      return map[toString.call(obj)];
    },
    //加一个转换方法
    changeHtml(html) {
      try {
        let json = html2json(html); //转json
        let nj = this.recursive(json); //遍历修改
        let nh = json2html(nj); //转html
        return nh;
      } catch (e) {
        console.log(e);
        return html;
      } finally {
      }
    },
    getThumbAuto(isChangeType) {
      if (this.type == 2) {
        this.thumbType = "0.9";
      } else {
        this.thumbType = "1";
      }

      switch (this.type) {
        case "1":
          // 图文
          this.thumbList = ["", "", ""];
          let editor = document.getElementsByClassName("mce-content-body")[0];
          let imgs = editor.getElementsByTagName("img");
          let thumb = [];
          let linkThumb = 0;
          for (var i = 0; i < imgs.length; i++) {
            if (
              imgs[i] &&
              (imgs[i].currentSrc.indexOf("dingxinwen.com") >= 0 ||
                imgs[i].currentSrc.indexOf("dingnews.net") >= 0 ||
                imgs[i].currentSrc.indexOf("dingxinwen.cn") >= 0 ||
                imgs[i].currentSrc.indexOf("dingduantest") >= 0) &&
              thumb.length < 3 &&
              imgs[i].classList.value != "videoIcon"
            ) {
              thumb.push(imgs[i].currentSrc);
            } else if (
              imgs[i].currentSrc.indexOf("dingxinwen.com") < 0 &&
              imgs[i].currentSrc.indexOf("dingnews.net") < 0 &&
              imgs[i].currentSrc.indexOf("dingduantest") < 0 &&
              imgs[i].currentSrc.indexOf("dingxinwen.cn") < 0
            ) {
              linkThumb++;
            }
          }
          if (linkThumb > 0) {
            this.$message({
              message: "外链图片不支持设置为封面",
              type: "warning",
            });
          }
          for (var j = 0; j < thumb.length; j++) {
            this.thumbList[j] = thumb[j];
          }
          break;
        case "2":
          // 视频
          if (this.resource_url.length == 0) {
            this.$message({
              message: "请先上传视频",
              type: "warning",
            });
            return;
          }
          this.thumbCutIndex = 0;
          this.dialogVisible = true;

          this.option.img = this.videoCover
            ? this.videoCover
            : this.originThumb;
          this.option.fixedNumber = this.thumbType == "0.9" ? [16, 9] : [4, 3];
          if (this.$refs.cropper) {
            this.$refs.cropper.reload();
          }

          break;
        case "3":
          // 图集
          this.thumbList = ["", "", ""];
          for (var i = 0; i < 3; i++) {
            if (this.resource_url[i]) {
              this.thumbList[i] = this.resource_url[i];
            }
          }
          break;
      }

      if (isChangeType) {
        let count = this.thumbList.filter((item) => item != "").length;
        if (count > 2) {
          this.thumbType = "3";
        } else if (count > 0) {
          this.thumbType = "1";
        } else {
          this.thumbType = "0";
        }
      }
    },
    submit(save_type, audit_uid) {
      if (!this.$route.query.uid) {
        if (this.title.length > 35) {
          this.$emit("titleTooLong");
          return;
        }
      }
      let selectedTime = "";
      if (this.publishTime) {
        selectedTime = new Date(this.publishTime).getTime();
      }
      if (this.title == "") {
        this.$message({
          message: "标题不能为空",
          type: "warning",
        });
      } else if (this.type != 2 && this.content == "") {
        this.$message({
          message: "正文不能为空",
          type: "warning",
        });
      } else if (this.type == 3 && this.resource_url.length == 0) {
        this.$message({
          message: "最少上传一张图片",
          type: "warning",
        });
      } else if (this.type == 2 && this.resource_url.length == 0) {
        this.$message({
          message: "请上传或者选择视频",
          type: "warning",
        });
      } else if (
        (this.thumbType == 1 || this.thumbType == 0.9) &&
        !this.thumbList[0] &&
        this.type != 2
      ) {
        this.$message({
          message: "请上传封面图",
          type: "warning",
        });
      } else if (
        this.thumbType == 3 &&
        (!this.thumbList[0] || !this.thumbList[1] || !this.thumbList[2])
      ) {
        this.$message({
          message: "请上传3张封面图",
          type: "warning",
        });
      } else if (this.accountId == "" && this.isEditor) {
        this.$message({
          message: "请选择顶端号",
          type: "warning",
        });
      } else if (this.editor_news_type == 0 && this.isEditor) {
        this.$message({
          message: "请选择编辑发稿类型",
          type: "warning",
        });
      } else if (this.isLocation == 1 && this.address == "") {
        this.$message({
          message: "请输入位置",
          type: "warning",
        });
      } else if (
        this.isClock == 1 &&
        (selectedTime < Date.parse(new Date()) + this.clockStartTime ||
          selectedTime > Date.parse(new Date()) + 604800000)
      ) {
        this.$message({
          message: `请选择${this.formatSeconds(
            this.clockStartTime
          )}至7天内的时间发布`,
          type: "warning",
        });
      } else {
        //初始化数据
        //将内容转成json
        let content = "";

        if (document.getElementsByClassName("mce-content-body").length) {
          let editorElem =
            document.getElementsByClassName("mce-content-body")[0];

          // if (
          //   editorElem
          //     .getElementById("tinymce")
          //     .innerHTML.indexOf(
          //       "https://obs.dingxinwen.com/video/20220626/f514bcbbc794acb60c862cb58d67c568.gif"
          //     ) >= 0
          // ) {
          //   this.$message({
          //     message: "图片加载中，请稍加等待或者手动重新上传",
          //     type: "warning",
          //     duration: 3000,
          //   });
          //   return;
          // }

          $(editorElem).find(".mce-offscreen-selection").remove();
          $(editorElem).find(".mce-visual-caret").remove();
          $(editorElem).find('p[data-mce-caret="after"]').remove();
          content = editorElem.innerHTML;

          let videoCover = editorElem.getElementsByClassName("get-cover");
          if (videoCover.length > 0) {
            videoCover = Array.from(videoCover);
            videoCover.forEach((elem, index) => {
              let videoUrl = elem.id,
                poster = elem.getElementsByClassName("videoCover")[0].src;
              $(
                `<p><span contenteditable="false" style="width: 100%;" data-mce-object="video" class="mce-preview-object mce-object-video" data-mce-p-controls="controls" data-mce-p-src="${videoUrl}"data-mce-selected="1" data-mce-html="${elem.getAttribute(
                  "data-originid"
                )}" data-mce-p-poster="${poster}"><video src="${videoUrl}" poster="${poster}" data-mce-poster="${poster}" data-mce-id="${elem.getAttribute(
                  "data-originid"
                )}" controls="controls" style="width: 100%;" width="100%" height="auto" frameborder="0"></video></span></p>`
              ).insertAfter($(elem));
              $(elem).remove();
            });
          }

          let figcaption = editorElem.getElementsByTagName("figcaption");
          if (figcaption.length > 0) {
            figcaption = Array.from(figcaption);
            figcaption.forEach((elem, index) => {
              elem.setAttribute("contenteditable", false);
            });
          }

          let videos = editorElem.getElementsByTagName("video");
          if (videos.length > 0) {
            videos = Array.from(videos);
            videos.forEach((elem, index) => {
              if (
                elem.parentNode &&
                elem.parentNode.getAttribute("data-mce-p-poster")
              ) {
                elem.poster = elem.parentNode.getAttribute("data-mce-p-poster");
              }
            });
          }

          let wrongWords = editorElem.getElementsByClassName("wrongWords");
          if (wrongWords.length > 0) {
            wrongWords = Array.from(wrongWords);
            wrongWords.forEach((elem, index) => {
              wrongWords.outerHTML = elem.innerHTML;
            });
          }

          content = editorElem.innerHTML;
          content = this.changeHtml(content);

          let topics = editorElem.getElementsByClassName("topicid");
          if (topics.length > 0) {
            topics = Array.from(topics);
            let contentSlice = content.split(' class="topicid"');
            let html = contentSlice[0];
            topics.forEach((elem, index) => {
              html +=
                ' class="topicid" onclick="clickTopic(' +
                elem.id +
                ')"' +
                contentSlice[index + 1];
            });
            content = html;
          }
        }

        let data = {
          title: this.title,
          content:
            this.type == 1
              ? content
              : this.type == 2 && this.content == ""
              ? " "
              : this.content,
          resource_url: JSON.stringify(this.resource_url),
          category: this.channel,
          type: this.type,
          save_type: save_type,
          material_ids: this.material_ids,
          creator_source: 2,
        };
        // 根据不同的数据判断添加参数
        if (this.belong_id) {
          data.belong_id = this.belong_id;
        }
        // 封面
        if (this.thumbType == 1) {
          // 单图
          data.cover_show_type = 1;
          let thumb = [];
          thumb.push(this.thumbList[0]);
          data.cover_url = this.videoCover
            ? JSON.stringify([this.videoCover])
            : JSON.stringify(thumb);
        } else if (this.thumbType == 0.9) {
          // 无缝大图
          data.cover_show_type = 2;
          let thumb = [];
          thumb.push(this.thumbList[0]);
          data.cover_url = this.videoCover
            ? JSON.stringify([this.videoCover])
            : JSON.stringify(thumb);
        } else if (this.thumbType == 3) {
          // 多图
          data.cover_show_type = 4;
          data.cover_url = JSON.stringify(this.thumbList);
        } else {
          // 标题无图
          data.cover_show_type = 3;
          data.cover_url = this.videoCover
            ? JSON.stringify([this.videoCover])
            : "[]";
        }
        // 顶端号
        if (this.isEditor) {
          data.u_id = this.accountId;
        }
        // 来源
        data.source = this.source;
        // 摘要
        data.abstract = this.abstract;
        // 作者
        data.u_nickname = this.isEditor ? this.accountName : this.authorName;
        // 编辑
        data.modify_user = this.editor;
        // 供稿记者
        if (this.reporter) {
          data.author = this.reporter;
        }
        // 内审人
        if (this.auditType == 1) {
          data.audit_uid = audit_uid;
        }
        // 是否允许赞赏
        data.reward = this.reward_auth ? this.allow_reward : 0;
        // 是否原创
        data.is_original = this.is_original;
        // 允许评论
        data.is_allow_comment = this.allowCommit == 0 ? "Y" : "N";
        // 允许广告
        data.is_allow_adv = this.allowAd == 0 ? "Y" : "N";
        // 定时发布
        if (this.isClock == 1) {
          data.clock_time = this.publishTime;
        }
        // 草稿同步
        if (this.$route.query.draftId && save_type == 2) {
          data.is_sync = 1;
        } else if (this.$route.query.draftId) {
          data.is_sync = 0;
        }
        data.empower = this.isEditor ? 1 : 0;
        if (this.$route.query.dhyId) {
          data.big_cloud_id = this.belong_id;
        }
        // 编辑老师uid
        if (this.$route.query.uid) {
          data.empower_id = this.$route.query.uid;
        }
        if (this.video_id) {
          data.video_id = this.video_id;
          data.is_hs_video = 1;
        }
        if (this.type == 2) {
          data.is_horizontal = this.is_horizontal;
          if (this.video_length > 0) {
            data.video_length = this.video_length;
          }
        }
        data.allow_ai_comment = this.allow_ai_comment;
        if (this.editor_news_type) {
          data.editor_news_type = this.editor_news_type;
        }
        if (this.$route.query.aa_id) {
          data.aa_id = this.$route.query.aa_id;
        }
        if (this.isEditor) {
          data.is_hidden = this.isHidden;
        }
        if (this.belongtoValue.length) {
          let belongto_user = [];
          this.belongtoValue.forEach((item) => {
            let d_id = item.split("/")[0];
            let u_id = item.split("/")[1];
            this.belongtoOriginList.forEach((item1) => {
              if (
                item1.belongto_user_id == u_id &&
                item1.belongto_d_id == d_id
              ) {
                belongto_user.push(item1);
              }
            });
          });
          data.belongto_user = JSON.stringify(belongto_user);
        }

        this.publishFn(data, save_type);
      }
    },
    publishFn(data, save_type) {
      if (this.dhyPublished) {
        this.$message({
          message: "该篇稿件已发布",
          type: "warning",
        });
        return;
      }

      if (this.submitting) {
        return;
      } else {
        this.submitting = true;
      }

      // 存储常用顶端号
      if (this.accountPickThisTime.u_id) {
        let accountHistory = localStorage.getItem("accountHistory");
        let accountChange = [];
        if (accountHistory) {
          accountChange = JSON.parse(accountHistory);
        }
        let has = false;
        accountChange.forEach((item) => {
          if (item.u_id == this.accountPickThisTime.u_id) {
            has = true;
          }
        });
        if (!has) {
          accountChange.push(this.accountPickThisTime);
        }
        localStorage.setItem("accountHistory", JSON.stringify(accountChange));
      }

      const loading = this.$loading({
        lock: true,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "hsla(0,0%,100%,.9)",
      });

      if (this.$route.query.draftId) {
        this.$axios
          .post(`${RESOURCE_HOST}/api/draft/edit`, data)
          .then((res) => {
            loading.close();

            if (res.data.code == 0) {
              if (this.isEditor) {
                this.submitting = false;
                this.$message({
                  message: "保存草稿成功，可生成预览链接",
                  type: "success",
                });
              } else {
                this.$router.push({
                  path: save_type == 1 ? "/draft" : "/personalScript",
                });
              }
            } else {
              this.$message.error(res.data.msg || res.data.data);

              this.submitting = false;
            }
          })
          .catch((error) => {
            loading.close();

            this.submitting = false;

            this.$message.error("服务端错误");
            console.log(error);
          });
      } else if (save_type == 1) {
        this.$axios
          .post(`${RESOURCE_HOST}/api/article/add`, data)
          .then((res) => {
            loading.close();

            if (res.data.code == 0) {
              this.global_id = res.data.data.global_id;

              this.relationTopic(save_type);
            } else {
              this.$message.error(res.data.msg || res.data.data);

              this.submitting = false;
            }
          })
          .catch((error) => {
            loading.close();

            this.submitting = false;

            this.$message.error("服务端错误");
            console.log(error);
          });
      } else if (this.$route.query.scriptId) {
        delete data.belong_id;
        data.nm_id = this.nm_id;
        if (
          (this.n_release_status == 5 ||
            this.n_release_status == 6 ||
            this.n_release_status == 7) &&
          this.n_id
        ) {
          data.n_id = this.n_id;
        }
        this.$axios
          .post(`${RESOURCE_HOST}/api/manuscript/editNew`, data)
          .then((res) => {
            loading.close();

            if (res.data.code == 0) {
              this.relationTopic(save_type);
            } else {
              this.$message.error(res.data.msg || res.data.data);

              this.submitting = false;
            }
          })
          .catch((error) => {
            loading.close();

            this.submitting = false;

            this.$message.error("服务端错误");
            console.log(error);
          });
      } else {
        this.$axios
          .post(`${RESOURCE_HOST}/api/article/add`, data)
          .then((res) => {
            loading.close();

            if (res.data.code == 0) {
              if (this.$route.query.dhyId) {
                this.dhyPublished = true;
              }

              this.global_id = res.data.data.global_id;

              this.relationTopic(save_type);
            } else {
              this.$message.error(res.data.msg || res.data.data);

              this.submitting = false;
            }
          })
          .catch((error) => {
            loading.close();

            this.submitting = false;

            this.$message.error("服务端错误");
            console.log(error);
          });
      }
    },
    relationTopic(save_type) {
      if (this.type == 1 && this.global_id) {
        //文稿绑定话题
        let topicArray = [];
        let editor = document.getElementsByClassName("mce-content-body")[0];
        let topics = editor.getElementsByClassName("topicid");

        for (let i = 0; i < topics.length; i++) {
          topicArray.push(topics[i].id);
        }

        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/relationTopic`, {
            global_id: this.global_id,
            hot_topic_id: topicArray.join(","),
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.$route.query.uid && this.isThemeWhite) {
                // 设置公祭主题
                this.setThemeCreate(save_type);
              } else {
                if (this.isEditor && save_type == 1) {
                  this.submitting = false;
                  this.$message({
                    message: "保存草稿成功，可生成预览链接",
                    type: "success",
                  });
                } else if (
                  !this.isEditor ||
                  this.$route.query.channelId !== undefined
                ) {
                  if (this.isEditor) {
                    setToken(this.$route.query.token);
                    localStorage.setItem("token", this.$route.query.token);
                  }

                  this.$router.push({
                    path: save_type == 1 ? "/draft" : "/personalScript",
                  });
                } else {
                  this.submitting = false;
                  this.$message({
                    message: "编辑成功，请关闭本页面",
                    type: "success",
                  });
                }
              }
            } else {
              this.$message.error(res.data.msg || res.data.data);

              this.submitting = false;
            }
          })
          .catch((error) => {
            this.$message.error("服务端错误");

            this.submitting = false;
          });
      } else if (this.global_id) {
        //视频、图集绑定话题
        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/relationTopic`, {
            global_id: this.global_id,
            hot_topic_id: this.topicIds.join(","),
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.$route.query.uid && this.isThemeWhite) {
                // 设置公祭主题
                this.setThemeCreate(save_type);
              } else {
                if (this.isEditor && save_type == 1) {
                  this.submitting = false;
                  this.$message({
                    message: "保存草稿成功，可生成预览链接",
                    type: "success",
                  });
                } else if (
                  !this.isEditor ||
                  this.$route.query.channelId !== undefined
                ) {
                  if (this.isEditor) {
                    setToken(this.$route.query.token);
                    localStorage.setItem("token", this.$route.query.token);
                  }

                  this.$router.push({
                    path: save_type == 1 ? "/draft" : "/personalScript",
                  });
                } else {
                  this.submitting = false;
                  this.$message({
                    message: "编辑成功，请关闭本页面",
                    type: "success",
                  });
                }
              }
            } else {
              this.$message.error(res.data.msg || res.data.data);

              this.submitting = false;
            }
          })
          .catch((error) => {
            this.$message.error("服务端错误");

            this.submitting = false;
          });
      } else {
        if (this.isEditor && save_type == 1) {
          this.submitting = false;
          this.$message({
            message: "保存草稿成功，可生成预览链接",
            type: "success",
          });
        } else if (
          !this.isEditor ||
          this.$route.query.channelId !== undefined
        ) {
          if (this.isEditor) {
            setToken(this.$route.query.token);
            localStorage.setItem("token", this.$route.query.token);
          }

          this.$router.push({
            path: save_type == 1 ? "/draft" : "/personalScript",
          });
        } else {
          this.submitting = false;
          this.$message({
            message: "编辑成功，请关闭本页面",
            type: "success",
          });
        }
      }
    },
    // 顶端号搜索
    getTopAccountList(query) {
      let request = {
        nickname: query,
        page: 1,
        size: 100,
        is_accurate: this.accountSearchType,
      };
      if (this.$route.query.aa_id) {
        request.aa_id = this.$route.query.aa_id;
      }
      this.$axios
        .post(`${USER_HOST}/user/topaccount/getTopAccountList`, request)
        .then((res) => {
          if (res.data.code == 0) {
            this.accountLoading = true;
            setTimeout(() => {
              this.accountLoading = false;
              this.accountList = res.data.data.returnData.filter((item) => {
                return (
                  item.u_nickname.toLowerCase().indexOf(query.toLowerCase()) >
                  -1
                );
              });
            }, 200);
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    accountPick(e) {
      this.accountList.forEach((item) => {
        if (item.u_id == e) {
          this.accountId = item.u_id;
          this.accountName = item.u_nickname;
          this.accountPickThisTime = item;
        }
      });
    },
    // 频道配置信息
    getChannelList() {
      this.$axios
        .get(
          `${NEWS_HOST}/admin/category/list?is_mp_show=${
            this.isEditor ? 0 : 1
          }${
            this.$route.query.aa_id ? "&aa_id=" + this.$route.query.aa_id : ""
          }`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data = res.data.data.filter((item) => item.name != "直播");
            res.data.data = res.data.data.filter(
              (item) => item.is_mp_show != 2
            );
            res.data.data.forEach((item) => {
              if (item.children) {
                item.children = item.children.filter(
                  (item1) => item1.is_mp_show != 2
                );
              }
            });
            if (this.type != 2) {
              res.data.data = res.data.data.filter(
                (item) => item.name != "视频" && item.name != "短视频"
              );
            }

            this.channels = res.data.data;

            if (this.isEditor && !this.$route.query.scriptId) {
              if (this.$route.query.channelId > 0) {
                this.channel = parseInt(this.$route.query.channelId);
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 提取关键词
    handleClickExtract(isGet) {
      this.$axios
        .get(`${NEWS_HOST}/admin/news/keyword?n_id=${this.n_id}`)
        .then((res) => {
          if (res.data.code == 0) {
            this.keywords = res.data.data;

            if (!res.data.data.length) {
              //this.$message.warning("该文章未匹配到关键词");
            } else if (isGet) {
              this.$message({
                message: "提取关键词成功",
                type: "success",
              });
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toThumbEdit(index) {
      this.thumbCutIndex = index;
      this.option.img = this.thumbList[index].split("?")[0];
      this.option.fixedNumber = this.thumbType == "0.9" ? [16, 9] : [4, 3];
      this.dialogVisible = true;
      if (this.$refs.cropper) {
        this.$refs.cropper.reload();
      }
    },
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], "1.jpg", { type: "image/jpeg" });
        HS_upload(
          file,
          (data) => {
            this.dialogVisible = false;

            this.$set(this.thumbList, this.thumbCutIndex, data.url);
          },
          (error) => {
            console.log(error);
          },
          (processPercent) => {
            console.log("processPercent:" + processPercent);
          }
        );
      });
    },
    fileChange(e) {
      let file = e.target.files[0];
      if (file) {
        const isIMAGE = file.type.indexOf("image/") >= 0;
        if (!isIMAGE) {
          this.$message.error("上传文件只能是图片格式！");
        } else {
          HS_upload(
            file,
            (data) => {
              if (this.type == 2) {
                this.thumbCutIndex = this.uploadIndex;
                this.option.img = data.url;
                this.option.fixedNumber =
                  this.thumbType == "0.9" ? [16, 9] : [4, 3];
                this.dialogVisible = true;
                if (this.$refs.cropper) {
                  this.$refs.cropper.reload();
                }
              } else {
                this.$set(this.thumbList, this.uploadIndex, data.url);
              }
            },
            (error) => {
              console.log(error);
            },
            (processPercent) => {
              console.log("processPercent:" + processPercent);
            }
          );
        }
      }
    },
    isClockChange() {
      this.isClock = "1";
      if (!this.clockPreinstall) {
        this.publishTime = this.formatDate(
          Date.parse(new Date()) + this.clockStartTime + 60000
        );
      }
      this.clockShow = true;
    },
    closeClockDialog(done) {
      this.isClock = "0";
      done();
    },
    clockSubmit() {},
    formatDate(d) {
      var now = new Date(parseFloat(d));
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var date = now.getDate();
      var hour = now.getHours();
      var minute = now.getMinutes();
      if (month >= 0 && month <= 9) {
        month = "0" + month;
      }
      if (date >= 0 && date <= 9) {
        date = "0" + date;
      }
      if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minute >= 0 && minute <= 9) {
        minute = "0" + minute;
      }
      return (
        year + "-" + month + "-" + date + " " + hour + ":" + minute + ":00"
      );
    },
    formatSeconds(value) {
      let result = parseInt(value) / 1000;
      let h = Math.floor(result / 3600);
      let m = Math.floor((result / 60) % 60);
      let s = Math.floor(result % 60);

      let res = "";
      if (h != "0") res += `${h}小时`;
      if (m != "0") res += `${m}分钟`;
      if (s != "0") res += `${s}秒钟`;

      return res;
    },
    getAiAbstract() {
      let clearContent = this.getClearContent();
      if (clearContent.length < 50) {
        if (this.type == 1) {
          this.$message({
            message: "稿件内容必须大于等于50个字",
            type: "warning",
          });
        } else {
          this.$message({
            message: "正文内容必须大于等于50个字",
            type: "warning",
          });
        }
      } else {
        this.aiTitleLoading = true;
        this.$axios
          .post(`${RESOURCE_HOST}/common/aiCreate/abstract`, {
            text: clearContent,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.abstract = res.data.data.abstract;
              this.aiTitleLoading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    getClearContent() {
      if (
        this.type == 1 &&
        document.getElementsByClassName("mce-content-body").length
      ) {
        let editorElem = document.getElementsByClassName("mce-content-body")[0];
        let content = editorElem.innerHTML;
        return content
          .replace(/<[^<>]+>/g, "")
          .replace(/&nbsp;/gi, "")
          .replace(/\s/g, "");
      } else if (this.type == 2 || this.type == 3) {
        return this.content
          .replace(/<[^<>]+>/g, "")
          .replace(/&nbsp;/gi, "")
          .replace(/\s/g, "");
      } else {
        return "";
      }
    },
    //获取创作者公祭主题白名单
    getThemeWhiteUser() {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/theme/getThemeWhiteUser?u_id=${this.$route.query.uid}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.isThemeWhite = res.data.data.is_white == 0 ? false : true;
            if (this.isThemeWhite && this.$route.query.scriptId) {
              this.getThemeCreate();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    setThemeCreate(save_type) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/theme/setThemeCreate`, {
          u_id: this.$route.query.uid,
          global_id: this.global_id,
          is_del: this.setTheme,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (this.isEditor && save_type == 1) {
              this.submitting = false;
              this.$message({
                message: "保存草稿成功，可生成预览链接",
                type: "success",
              });
            } else if (
              !this.isEditor ||
              this.$route.query.channelId !== undefined
            ) {
              if (this.isEditor) {
                setToken(this.$route.query.token);
                localStorage.setItem("token", this.$route.query.token);
              }

              this.$router.push({
                path: save_type == 1 ? "/draft" : "/personalScript",
              });
            } else {
              this.submitting = false;
              this.$message({
                message: "编辑成功，请关闭本页面",
                type: "success",
              });
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getThemeCreate() {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/theme/getThemeCreate?u_id=${this.$route.query.uid}&global_id=${this.global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.setTheme = res.data.data.is_theme == 0 ? "1" : "0";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getUserLevelList() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserLevelList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.user_privilege_list.forEach((item) => {
              if (item.privilege_name == "原创声明" && item.is_open == 1) {
                //this.original_auth = true;
              } else if (
                item.privilege_name == "用户赞赏" &&
                item.is_open == 1
              ) {
                this.reward_auth = true;
              } else if (
                item.privilege_name == "创建合集" &&
                item.is_open == 1
              ) {
                this.$emit("sendRight", true);
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    generateNewsDraftPreview() {
      if (!this.global_id) {
        this.$message({
          message: "请先保存草稿",
          type: "warning",
        });
        return;
      }
      this.$axios
        .post(`${SWNEWS_HOST}/admin/news/generateNewsDraftPreview`, {
          global_id: this.global_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.qrCodeShow = true;
            this.$nextTick(() => {
              let qrCodeElem = document.getElementById("qrCode");
              qrCodeElem.innerHTML = "";
              let qrCode = new QRCode(this.$refs.qrCodeDiv, {
                text:
                  (window.location.href.indexOf("dingxinwen.com") > 0 ||
                  window.location.href.indexOf("topnews.cn") >= 0
                    ? "https://static.dingxinwen.com"
                    : "https://static.dingnews.net") +
                  `/dd-sharepage/preview/index.html#/pages/preview/detail?id=${res.data.data}`,
                with: 280,
                height: 280,
              });
              qrCode._el.title = "";
            });
          } else {
            this.$message.error(res.data.msg || res.data.data);
          }
        });
    },
    toTop() {
      if (this.type == 1) {
        window.scrollTo(0, 0);
      } else {
        let memberContainer =
          document.getElementsByClassName("memberContainer")[0];
        memberContainer.scrollTop = 0;
      }
    },
    toBottom() {
      if (this.type == 1) {
        window.scrollTo(0, document.body.scrollHeight);
      } else {
        let memberContainer =
          document.getElementsByClassName("memberContainer")[0];
        memberContainer.scrollTop = memberContainer.scrollHeight;
      }
    },
    getIsOriginalDesc() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/news/getIsOriginalDesc`)
        .then((res) => {
          if (res.data.code == 0) {
            this.originalList = res.data.data;

            this.$nextTick(() => {
              if (this.$route.query.draftId) {
                this.belong_id = this.$route.query.draftId;
                this.getDraftDetail();
              } else if (this.$route.query.dhyId) {
                this.belong_id = this.$route.query.dhyId;
                this.getDhyDetail();
              } else if (this.$route.query.mediaId) {
                this.belong_id = this.$route.query.mediaId;
                this.getMediaDetail();
              }
              this.getAuditUser();
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    originalClick(item) {
      if (this.is_original == item.is_original) {
        this.is_original = "0";
      } else {
        this.is_original = item.is_original;
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;

        this.$axios
          .get(
            `${SWNEWS_HOST}/admin/accountUser/getUserListWithDepartment?u_name=${query}&page=1&size=100`
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.loading = false;
              this.belongtoOriginList = this.removeDuplicatesByKeys(
                this.belongtoOriginList.concat(res.data.data.returnData || []),
                ["belongto_d_id", "belongto_user_id"]
              );
              this.belongtoOptions = [];
              let arr = res.data.data.returnData || [];
              arr.forEach((item) => {
                if (item.belongto_user_id) {
                  this.belongtoOptions.push({
                    value: item.belongto_d_id + "/" + item.belongto_user_id,
                    label: `${item.belongto_user_name}(${item.belongto_d_name})`,
                  });
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.options = [];
      }
    },
    removeDuplicatesByKeys(arr, keys) {
      const seen = new Set();
      return arr.filter((item) => {
        // 构建唯一签名:按 keys 顺序拼接对应属性值
        const signature = keys.map((key) => item[key]).join("|");
        if (seen.has(signature)) {
          return false;
        }
        seen.add(signature);
        return true;
      });
    },
  },
};
</script>

<style lang="scss">
.el-input--suffix .el-input__inner {
  background: #f6f7f9;
  border: 0px;
}
.el-textarea__inner {
  background: #f6f7f9;
  border: 0px;
}
.accountSearchContain {
  display: flex;
  align-items: center;

  .accountHead {
    width: 28px;
    height: 28px;
    margin-right: 6px;
  }
}
</style>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  width: 856px;
  padding: 0 40px 56px 40px;
  background-color: #fff;
  margin-bottom: 88px;

  .mainContainer {
    box-sizing: border-box;
    width: 100%;
    margin: 0 auto;
    background: white;

    .setContainer {
      display: flex;
      align-items: center;
      padding-top: 32px;

      &:first-child {
        padding-top: 0px;
      }

      .label {
        width: 70px;
        margin-right: 5px;
        font-weight: bold;
        flex-shrink: 0;
        text-align: right;
        margin-right: 30px;

        .require {
          color: red;
          vertical-align: middle;
          margin-left: 3px;
        }

        .countNum {
          font-size: 12px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #999999;
          line-height: 17px;
          margin-left: 8px;
        }
      }

      .alignLabel {
        vertical-align: top;
      }

      .thumbTypeContainer {
        width: 100%;
        display: inline-flex;
        flex-direction: column;

        .radioContainer {
          display: flex;
          flex-direction: column;
        }
      }

      /deep/.el-input,
      .el-select,
      .el-textarea,
      .el-autocomplete {
        width: 100%;
        margin: 0;
      }

      /deep/.el-input__count {
        background: #f6f7f9;
      }

      .chooseAudit {
        width: 100px;
        margin: 10px 0;
      }

      .chooseLocation {
        width: 100px;
        margin: 10px 0;
      }

      .keywordsbox {
        min-width: 200px;
        border-radius: 4px;
        background: rgb(246, 247, 249);
        line-height: 40px;
        min-height: 40px;
        display: flex;
        &__left {
          padding: 0 15px 4px 15px;
          flex: 0 0 100%;
          display: flex;
          flex-wrap: wrap;
          .noData {
            line-height: 30px;
            height: 32px;
            margin-top: 4px;
            color: #606266;
          }
          &__item {
            margin: 4px 6px 0 0px;
            display: block;
            padding: 0 6px;
            border-radius: 4px;
            background-color: #fff;
            line-height: 30px;
            color: #909399;
            border: 1px solid #e9e9eb;
          }
        }
        &__right {
          flex: 1;
          background: #ea0e0e;
          border-radius: 0 4px 4px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 18px;
          cursor: pointer;
        }
      }

      .getThumbAuto {
        color: #165dff;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        margin-left: 32px;
        cursor: pointer;
        margin-top: -2px;
      }

      .accountSearchType {
        display: flex;
        .el-radio {
          padding: 2px 0;
        }
      }

      .abstractContain {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .getAiAbstract {
          color: #ea0e0e;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          cursor: pointer;
          margin-top: 4px;
          margin-left: 8px;
        }
      }
    }

    .originalContainer {
      align-items: flex-start;

      .radioContainer {
        display: inline-flex !important;
        flex-direction: row !important;
        flex-wrap: wrap;

        .originalRadio {
          width: fit-content;
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-bottom: 32px;

          .originalIcon {
            height: 16px;
            margin-right: 4px;
          }

          .originalText {
            color: #666666;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            margin: 0 32px 0 0;
          }
        }
      }
    }

    .setContainer:first-child,
    .setContainer:last-child {
      border-bottom: 0;
    }

    .thumbContainer {
      display: flex;
      padding-left: 105px;

      .thumbEditContainers {
        width: 213px;
        height: 124px;
        margin: 15px 10px 0 0;
        cursor: pointer;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }

        .thumbEditContainer {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .thumbBtn {
            font-size: 14px;
            line-height: 20px;
            color: #fff;
            text-align: center;
            width: 50px;
            margin: 17px auto 0 auto;

            &:first-child {
              margin-top: 0;
            }
          }
        }
      }
    }
  }

  .normalScript {
    border-top: 1px solid #e5e6eb;

    .setContainer {
      &:first-child {
        padding-top: 32px;
      }
    }
  }

  .submitBtnContainer {
    height: 72px;
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    z-index: 1;

    .innerContainer {
      width: 856px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .submitBtn {
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        line-height: 36px;
        display: inline-block;
        margin-left: 12px;
      }

      .submitBtn[type="primary"] {
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }

      .leftPart {
        display: flex;

        .toTopContain {
          display: flex;
          cursor: pointer;
          margin-right: 24px;

          .topText {
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
          }

          .toTopIcon {
            height: 16px;
            margin-left: 4px;
          }
        }
      }

      .rightPart {
        display: flex;

        .el-button {
          margin-left: 12px;
        }
      }
    }
  }

  #upload {
    display: none;
  }

  .mapContainer {
    /deep/.el-dialog__body {
      padding-top: 10px;
      position: relative;

      #container {
        margin-top: 20px;
        widows: 100%;
        height: 500px;
      }

      .searchMap {
        width: 70% !important;
        max-width: 600px;
        margin-right: 20px;

        .el-input__inner {
          width: 100%;
        }
      }

      #panel {
        position: absolute;
        background-color: white;
        max-height: 500px;
        overflow-y: auto;
        top: 80px;
        right: 10px;
        width: 280px;
      }
    }
  }

  /deep/.auditDialog {
    .el-dialog__body {
      padding-top: 5px;
      padding-bottom: 15px;
    }

    .el-tabs__content {
      height: 60vh;
    }

    .publicScroll {
      height: 100%;
      overflow-y: scroll;
    }

    .recentAuditContainer {
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-radio {
        margin: 10px 0;
      }
    }
  }

  .thumbCutContainer {
    /deep/.el-dialog__body {
      padding-bottom: 10px;
      padding-top: 0;

      .avatar-uploader {
        background: red !important;
        width: 150px;
        height: 150px;
        text-align: center;
        line-height: 150px;
      }

      .el-icon-plus {
        width: 150px;
        height: 150px;
        font-size: 30px;
      }

      .cropper-content {
        width: 100%;
        height: 700px;
        background: pink;
      }

      .cropper {
        width: 100%;
        height: 700px;
        background: yellow;
      }

      .cropper-modal {
        background: rgba(0, 0, 0, 0.2) !important;
      }

      .cropper-view-box {
        img {
          display: none;
        }
      }
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }

  .qrCodeDialog {
    /deep/#qrCode {
      img {
        width: 280px;
        height: 280px;
      }
    }
  }

  .clockDialog {
    .intro {
      margin: 0 0 8px 0;
      color: #606266;
    }

    .timeView {
      color: #999999;

      .timeSelected {
        color: #606266;
        padding: 0 10px;
      }
    }

    /deep/.el-dialog__body {
      padding-bottom: 10px;
    }

    .el-input {
      margin-bottom: 8px !important;
    }

    /deep/.el-input__inner {
      width: 100% !important;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 136px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }
}
</style>
